// CDN Configuration for Video and Image Assets
// Cloudflare R2 CDN URL for ADASTRA assets

// Hardcoded CDN URL for production reliability
const CDN_BASE_URL = 'https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev';

export const getVideoUrl = (filename) => {
  // Always use CDN URL in production
  return `${CDN_BASE_URL}/${filename}`;
};

export const getImageUrl = (filename) => {
  // Always use CDN URL for images in production
  return `${CDN_BASE_URL}/${filename}`;
};

// Export CDN base URL for direct use if needed
export { CDN_BASE_URL };
